export const REDUCER_NAME = "homeNewsCategories";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOMENEWSCATEGORIES = `${REDUCER_NAME}/SET_HOMENEWSCATEGORIES`;
